import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  deDE,
} from '@mui/x-data-grid';
import React, { useCallback, useMemo, useState } from 'react';
import { IPartner } from '../../../interfaces/IPartner';

interface IProps {
  allPartners: IPartner[];
  selectedPartners: IPartner[];
  setSelectedPartners: React.Dispatch<React.SetStateAction<IPartner[]>>;
  unmount: () => void;
}

export const PartnerDialog: React.FC<IProps> = ({
  allPartners,
  selectedPartners,
  setSelectedPartners,
  unmount,
}) => {
  const [selection, setSelection] = useState<GridRowId[]>(
    selectedPartners.map(x => x.id)
  );

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'Nr.',
        width: 70,
      },
      {
        field: 'Company',
        headerName: 'Firma',
        renderCell: ({ row }: GridRenderCellParams<IPartner>) =>
          row.Contact_Person.Company?.company_name || '',
        flex: 1,
      },
      {
        field: 'Ansprechpartner',
        headerName: 'Ansprechpartner',
        renderCell: ({ row }: GridRenderCellParams<IPartner>) =>
          `${row.Contact_Person.firstname} ${row.Contact_Person.lastname}`,
        flex: 1,
      },
    ],
    []
  );

  const onSubmit = useCallback(() => {
    setSelectedPartners([...allPartners.filter(p => selection.includes(p.id))]);
    unmount();
  }, [allPartners, selection, setSelectedPartners, unmount]);

  return (
    <Dialog open={true} onClose={unmount} maxWidth='md' fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        Partner hinzufügen
        <IconButton onClick={unmount} size='small'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DataGrid
          sx={{ mt: 2 }}
          autoHeight
          checkboxSelection
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          rows={allPartners}
          onRowSelectionModelChange={newRowSelectionModel =>
            setSelection([...newRowSelectionModel])
          }
          rowSelectionModel={selection}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 50,
              },
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={unmount}>
          Abbruch
        </Button>
        <Button
          variant='contained'
          onClick={onSubmit}
          disabled={selection.length === 0}
        >
          Übernehmen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
